import React from "react";
import "./conclave css files/contentsection.css";
const timer_logo = require("../../assets/conclave assets/timer.svg");

const agendaContent = [
  {
    timeContent: ` 8:30AM - 9:30AM`,
    blueContent: ``,
    extraParagraphContent: `<p>Registration</p>`,
  },
  {
    timeContent: `9:30AM - 9:45AM`,
    blueContent: ``,
    extraParagraphContent: `<p>Inaugural ceremony-Lighting of the Lamp</p>`,
  },
  {
    timeContent: `9:50AM - 10:00AM`,
    blueContent: ``,
    extraParagraphContent: `<p>Opening  &amp; welcome note by<strong>&nbsp;Mrs.Puja Saluja -Founder &amp; CEO,</strong>Dynamic World Education Community (DWEC)</p>`,
  },
  {
    timeContent: `10:02AM - 10:07AM`,
    blueContent: ``,
    extraParagraphContent: `<p>Special welcome and felicitation of dignitaries by <strong>Mr. Varun Khosla - Chairman,</strong>Dynamic World Education Community (DWEC)</p>`,
  },
  {
    timeContent: `10:15AM - 10:55AM`,
    blueContent: `POWER TALKS`,
    extraParagraphContent: `<ul>
                              <li><strong>Mr. Amitabh Kant - CEO, NITI Aayog </strong> (Chief Guest)</li>
                              <li><strong>Prof Anil D. Sahasrabudhe - Chairman</strong>, All India Council for Technical Education (AICTE) - (Guest of Honour) </li>
                              <li><strong>Mr. Ved Mani Tiwari - COO</strong>, National Skill Development Corporation (NSDC) - (Guest of Honour)</li>
                              <li><strong>Dr. Biswajit Saha - Director</strong>, Central Board of Secondary Education (CBSE).</li>
                              <li><strong>Mr. Varun Khosla - Chairman</strong>, Dynamic, World Education Community (DWEC)</li>
                            </ul>
                            <p>The Power talks will be moderated by <strong>Ms.Puja Saluja-Founder & CEO, Dynamic, World Education Community (DWEC)</strong></p>`,
  },
  {
    timeContent: `10:55AM - 11:00AM`,
    blueContent: ``,
    extraParagraphContent: `<p>Chief Guest Keynote address by <strong>Mr.Amitabh Kant</strong> - CEO,NITI Aayog</p>`,
  },
  {
    timeContent: `11:05AM - 11:15AM`,
    blueContent: ``,
    extraParagraphContent: `<p>Special remarks By <strong>Prof.Anil Sahasrabudhe</strong> - Chairman, All India Council for Technical Education</p>`,
  },
  {
    timeContent: `11:20AM - 11:30AM`,
    blueContent: ``,
    extraParagraphContent: `<p>Special remarks By <strong>Mr.Ved Mani Tiwari </strong>- COO, National Skill Development Corporation(NSDC)</p>`,
  },
  {
    timeContent: `11:35AM - 12:10AM`,
    blueContent: `Panel Discussion 1 - The Future of Global Education`,
    extraParagraphContent: `<ul>
                              <li><strong>Padma Shri Najma Akhtar - Vice Chancellor,</strong>  Jamia Millia Islamia University (Delhi)</li>
                              <li><strong>Mr.M.Shribharat - President,</strong> GITAM Group of Institutions (South India)</li>
                              <li><strong>Mrs.Neeta Raina - HOD,</strong> Admissions and Communications - Pathways School (Gurgaon)</li>
                              <li><strong>Prof(Dr) Vandana Narang - Dean Academic,</strong> National Institute of Fashion Technology (New Delhi)</li>
                              <li><strong>Prof Gisela Lohlein - University President,</strong> - University President, New School of Architecture and Design (San Diego USA)</li>
                              <li><strong>Dr. Mike Guerra - Vice President,</strong>  LincoIn University (California USA)</li>
                            </ul>
                            <p>The Power talks will be moderated by <strong>Mr. Vineet Mehrotra</strong> - President, Dynamic World Education Community (DWEC)</p>`,
  },
  {
    timeContent: `12:15PM - 12:25PM`,
    blueContent: ``,
    extraParagraphContent: `<p><strong>Stand-alone Presentation by Romit Bajaj</strong> - Regional Head North,HSBC</p>`,
  },
  {
    timeContent: `12:30PM - 01:10PM`,
    blueContent: `Panel Discussion  - Making the Gen Z ready for the jobs of tomorrow`,
    extraParagraphContent: `<ul>
                              <li><strong>Mr. Dalip Sharma - Executive Chairman,</strong>Association of Indian Principals (AIP)</li>
                              <li><strong>Ms.Preeti Arora - Digital Education & Partnerships,</strong>  Trainer Assessor Enablement (NSDC)</li>
                              <li><strong>Dr.Kalyankumar Hatti - Founder & Chief Mentor,</strong>  Metamorphosis Engg & Skill Dev Pvt Ltd & MetaInspire Global Foundation</li>
                              <li><strong>Mr.Sanjay Viswanathan - Chairman & CEO,</strong>  Ed4All</li>
                              <li><strong>Mr.Arunabh Varma - CEO & Founder,</strong>  Intercell</li>
                              <li><strong>Ms.Deepti Lamba - CEO,</strong>  EdiQue Solutions</li>
                              <li><strong>Mr.Vedant Khaitan - Managing Trustee,</strong>  Khaitan School (Noida)</li>
                              <li><strong>Dr.Shafali Bahl Shah - Corporate HR Expert</strong> </li>
                            </ul>
                            <p>The Power talks will be moderated by <strong>Mr. Varun Khosla - Chairman,</strong> Dynamic World Education Community (DWEC)</p>`,
  },
  {
    timeContent: `01:15PM - 01:25PM`,
    blueContent: `Learn N Inspire Visionary School Model Presentation`,
    extraParagraphContent: `<p>Stand-alone address  by <strong>Dr.Kalyankumar Hatti</strong> - Founder & Chief Mentor, Metamorphosis Engg & Skill Dev Pvt Ltd & MetaInspire Global Foundation</p>`,
  },
  {
    timeContent: `01:30PM - 02:25PM`,
    blueContent: ``,
    extraParagraphContent: `<p>Networking Lunch</p>`,
  },
  {
    timeContent: `02:25PM - 03:15PM`,
    blueContent: ``,
    extraParagraphContent: `<p><strong>Special round table Networking.</strong></p>`,
  },
  {
    timeContent: `03:15PM - 03:25PM`,
    blueContent: ``,
    extraParagraphContent: `<p>Special Address by  <strong>Dr. M.P. Poonia, Vice Chairman</strong>  All India Council for Technical Education  (AICTE).</p>`,
  },
  {
    timeContent: `03:30PM - 04:10PM`,
    blueContent: `(Panel Discussion - New age career Counseling)`,
    extraParagraphContent: `<ul>
                              <li><strong>Dr.Tabrez Ahmad - Vice Chancellor</strong>,G D Goenka Group of Institutions</li>
                              <li><strong>Prof Christopher Abraham - CEO & Head</strong>, Dubai Campus - S P Jain School of Global Management (Dubai)</li>
                              <li><strong>C.V Srikanth - Globally Certified Mentor</strong>,Life Coach - Live Your Knowledge</li>
                              <li><strong>Dr. Vasudha Neel Mani - Principal</strong>, Rockwoods International School,Udaipur</li>
                              <li><strong>Mr.Alan Bahia - CEO</strong>, Alphabet Education Group</li>
                              <li><strong>Ms.Meenu Mehrotra - Certified Archetypal Consultant</strong>,Certified NLP Practioner,Spiritual Director & Author Of 7 books</li>
                              <li><strong>Mr.Jitender Kumar - Memory Grand Master</strong></li>
                            </ul>
                            <p>The session will be moderated by <strong>Mr.Ahsan Khan,COO & Executive Director,</strong> Dynamic World Education Community (DWEC)</p>
                              <p>To be followed by the unveiling of innovative technology counselling tools for students by <strong>Mr.Vineet & Mr.Ahsan,</strong> Dynamic World Education Community (DWEC)</p>`,
  },
  {
    timeContent: `04:20PM - 04:30PM `,
    blueContent: `Education + Skills + Jobs = (Digital) Infrastructure. A 100yr Growth Story in India.`,
    extraParagraphContent: `<p>Stand-alone address By <strong>Mr.Sanjay Viswanathan</strong> - Chairman & CEO, Ed4All</p>`,
  },
  {
    timeContent: `04:35PM - 04:45PM`,
    blueContent: ``,
    extraParagraphContent: `<p>Session on Educational Loan Support By <strong>Ms.Puja Saluja - Founder & CEO</strong>,Dynamic World Education Community (DWEC)</p>`,
  },
  {
    timeContent: `04:50PM - 05:35PM`,
    blueContent: `Panel Discussion - Pathways - Gateway to affordable education`,
    extraParagraphContent: `<ul>
                              <li><strong>Dr. Madhu Chitkara  - Pro Chancellor</strong>,Chitkara University</li>
                              <li><strong>Prof. Ashwni - Pro Vice Chancellor & Dean </strong>, (International Affairs), IGDTUW</li>
                              <li><strong>Dr. Amitabh Upadhya - President</strong>,Global Business Studies (Dubai)</li>
                              <li><strong>Mr. Aman Mittal - Vice President</strong>, , Lovely Professional University (LPU)</li>
                              <li><strong>Prof. Anurag Singh - Director</strong>, Institute of Business Management, GLA University</li>
                              <li><strong>Dr. Ameeta Mulla Wattal - Chairperson & ED</strong>,DLF Foundation Schools & Scholarship Programs </li>
                              <li><strong>Mr. Saurav Anand - Country Advisor</strong>,South Asia, The University of Lethbridge, Canada </li>
                            </ul>
                            <p>The session will be moderated by <strong>Mr. Rachit Khanna - Director (Operations)</strong>, Dynamic World Education Community (DWEC)</p>`,
  },
  {
    timeContent: `05:35PM - 05:40PM`,
    blueContent: `Learn N Inspire Visionary College Model presentation`,
    extraParagraphContent: `<p>Stand-alone address by <strong>Dr Kalyankumar Hatti - Founder & Chief Mentor, </strong> - Metamorphosis Engg & Skill Dev Pvt Ltd & Metalnspire Global Foundation</p>`,
  },
  {
    timeContent: `05:40PM - 05:50PM`,
    blueContent: ``,
    extraParagraphContent: `<p>recognition and felicitation ceremony of educational institutions by <strong>Mr.Ved Mani Tiwari</strong> - COO, NSDC</p>`,
  },
  {
    timeContent: `05:50PM - 06:30PM`,
    blueContent: ``,
    extraParagraphContent: `<p>Vote of thanks by Mr. Ahsan Khan,  COO & Executive Director, Dynamic World Education Community (DWEC)</p>`,
  },
  // {
  //   timeContent: `07:35PM - 08:30PM`,
  //   blueContent: ``,
  //   extraParagraphContent: `<p>Cultural presentation</p>`,
  // },
];

function ContentAgendaSection(props) {
  return (
    <div className="content_agenda_main_section_container" id="Agenda">
      <div className="content_agenda_under_main_container">
        {agendaContent.map((perAgendaContent) => {
          return (
            <div className="logo_time_title_text_container" key={Math.random()}>
              <div className="logo_text_container_agenda">
                <div className="logo_timer_container">
                  <img src={timer_logo.default} alt="timer" loading="lazy" />
                </div>

                <p className="timer_content_bold">
                  {perAgendaContent.timeContent}{" "}
                  <br></br>
                  <span className="blue_text">
                    {perAgendaContent.blueContent}
                  </span>
                </p>
              </div>
              <div
                className="extra_content_text_agenda"
                dangerouslySetInnerHTML={{
                  __html: perAgendaContent.extraParagraphContent,
                }}
              ></div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default ContentAgendaSection;
